export const insuranceColumns = [
  { label: 'Insurance ID', variations: [], value: 'insurance_id' },
  { label: 'Insurance name', variations: [], value: 'insurance_name' },
  { label: 'Insurance type', variations: [], value: 'insurance_type' },
  {
    label: 'Insurance member ID',
    variations: ['Insurance ID Number', 'insurance id number'],
    value: 'insurance_member_id'
  },
  { label: 'Insurance group number', variations: [], value: 'insurance_group_number' },
  { label: 'Insurance plan name', variations: [], value: 'insurance_plan_name' },
  {
    label: 'Insurance policy start date',
    variations: ['Policy Start Date', 'policy start date'],
    value: 'insurance_policy_start_date'
  },
  {
    label: 'Insurance policy end date',
    variations: ['Policy End Date', 'policy end date'],
    value: 'insurance_policy_end_date'
  },
  { label: 'Insurance relation', variations: [], value: 'insurance_relation' },
  {
    label: 'Insured first name',
    variations: [],
    value: 'insured_first_name'
  },
  {
    label: 'Insured middle name',
    variations: [],
    value: 'insured_middle_name'
  },
  {
    label: 'Insured last name',
    variations: [],
    value: 'insured_last_name'
  },
  {
    label: 'Insurance other relation date',
    variations: [],
    value: 'insurance_other_relation_date'
  },
  {
    label: 'Insurance other relation phone',
    variations: [],
    value: 'insurance_other_relation_phone'
  },
  { label: 'Insurance relation address', variations: [], value: 'insurance_relation_address' }
];
